import type { Maybe } from '@adornis/base/utilTypes.js';
import type { ColorType } from '@adornis/chemistry/elements/theming/coloring-system.js';

export function getColor(
  institutionColor: Maybe<string>,
  globalColor: Maybe<string>,
  defaultColor: Maybe<ColorType | string>,
) {
  if (institutionColor) return institutionColor;
  if (globalColor) return globalColor;
  return defaultColor as string;
}
